import router from '../router/index'
import store from '../store/index'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样师
import { Message } from 'element-ui'
import utils from '@/utils/utils'

const whiteList = ['/login', '/forget'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  if (utils.getToken()) {
    if (to.path === '/login' || to.path === '/forget') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      next()
    }
  } else if (to.query.Authorization) {
    store.commit('user/SET_TOKEN', to.query.Authorization)
    
    next()
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next()
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})
